module.exports = __webpack_public_path__ + "img/quest_icon_0019_time.c4814cb4.png";